// The canonical analytics key for the AI assistant feature.
// Kept as 'agent' to preserve continuity with historical analytics data.
export const kAnalyticsFeatureAgent = 'agent'

// The drafts list (/dashboard/m/:matterId/drafts). Not a chat route, so it does not inherit 'agent'.
export const kAnalyticsFeatureDraftPage = 'draft_page'

// The canonical analytics key for Continuous Matter Drive Sync events (DAT-12).
export const kAnalyticsFeatureMatterDriveSync = 'matter_drive_sync'

// Saved matter tables. Explicit so a table opened from chat is not stamped agent.
export const kAnalyticsFeatureTables = 'tables'

// Fallback matterId sent to Amplitude when no matter is in scope at the call site.
export const kNoMatterId = 'none'
